import type { OnboardingAccent } from "./types";

/**
 * @description Agent Name 到 Accent 颜色的映射（不区分大小写，统一使用小写键）
 * @remarks 基于后端返回的 agent name 进行映射
 */
const AGENT_ACCENT_MAP: Record<string, OnboardingAccent> = {
  edggy: "brand",
  sentiment: "accent1",
  macro: "accent4",
  sector: "accent3",
  // 360我们把颜色改成粉色了
  "360": "red",
  // 自己新增的agent用黄色
  ta: "accent5",
};

/**
 * @description 根据 Agent Label 获取对应的 Accent 颜色（不区分大小写）
 * @param agentLabel - Agent Label
 * @returns Accent 颜色，如果未找到则返回 "accent5"
 */
export const getAccentByAgentLabel = (agentLabel: string): OnboardingAccent => {
  const normalizedLabel = agentLabel.toLowerCase().trim();
  return AGENT_ACCENT_MAP[normalizedLabel] ?? "accent5";
};
